export function getGeolocation(onSuccess, onError) {
  navigator.geolocation.getCurrentPosition(onSuccess, onError);
}